import Vue from 'vue';
import DialogModal from '@/components/DialogModal.vue';
import {DialogButton} from '@/components/DialogModal.vue';

interface DialogModalService {
    show(title: string, message: string, buttons: DialogButton[], closeOnOverlay?: boolean): Promise<void>;

    close(): void;
}

let dialogModalInstance: any = null;

const DialogModalPlugin = {
    install(vue: typeof Vue) {
        // Criar container para o DialogModal
        const container = document.createElement('div');
        container.id = 'dialog-modal-container';
        document.body.appendChild(container);

        // Montar o componente
        const DialogModalComponent = Vue.extend({
            components: {
                DialogModal,
            },
            render(h) {
                return h('dialog-modal', {ref: 'dialogModal'});
            },
        });

        const instance = new DialogModalComponent().$mount(container);
        dialogModalInstance = instance.$refs.dialogModal;

        // Registrar plugin global
        vue.prototype.$dialogModal = {
            show(
                title: string,
                message: string,
                buttons: DialogButton[],
                closeOnOverlay: boolean = true
            ): Promise<void> {
                return new Promise((resolve) => {
                    // Wrapper para resolver a promise quando fechar
                    const buttonsWithResolver = buttons.map(btn => ({
                        ...btn,
                        action: async () => {
                            if (btn.action) {
                                await btn.action();
                            }
                            resolve();
                        },
                    }));

                    dialogModalInstance.show(title, message, buttonsWithResolver, closeOnOverlay);
                });
            },
            close() {
                if (dialogModalInstance) {
                    dialogModalInstance.close();
                }
            },
        } as DialogModalService;
    },
};

export default DialogModalPlugin;

